var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        }
      },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md12: "" } },
                    [
                      _vm.estado_item === 1
                        ? _c(
                            "v-alert",
                            {
                              attrs: {
                                value: true,
                                type: "success",
                                transition: "scale-transition"
                              }
                            },
                            [
                              _vm._v(
                                "\n            ITEM DISPONIBLE\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.estado_item === 0
                        ? _c(
                            "v-alert",
                            {
                              attrs: {
                                value: true,
                                type: "error",
                                transition: "scale-transition"
                              }
                            },
                            [_vm._v("\n            ITEM OCUPADO\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.estado_item === -1
                        ? _c(
                            "v-alert",
                            {
                              attrs: {
                                value: true,
                                type: "error",
                                transition: "scale-transition"
                              }
                            },
                            [
                              _vm._v(
                                "\n            ITEM INEXISTENTE\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  this.funcionario.item != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Nro de item :")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.item) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.padres_unidad != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Dependencia :")]),
                        _vm._v(
                          " " +
                            _vm._s(this.funcionario.padres_unidad) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.unidad != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Nombre unidad:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.unidad) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.cargo != null
                    ? _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Cargo:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.cargo) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.puesto != null
                    ? _c("v-flex", { attrs: { md6: "" } }, [
                        _c("strong", [_vm._v("Puesto:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.puesto) + "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  this.funcionario.sueldo != null
                    ? _c("v-flex", { attrs: { md6: "" } }, [
                        _c("strong", [_vm._v("Sueldo:")]),
                        _vm._v(
                          " " + _vm._s(this.funcionario.sueldo) + "\n        "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "date",
                          label: "Fecha de cambio",
                          rules: _vm.$validate(["required"]),
                          required: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.alertarAprobacion()
                          },
                          input: function($event) {
                            return _vm.esFeriadoOFinDeSemana(
                              _vm.form.fecha_desde,
                              1
                            )
                          }
                        },
                        model: {
                          value: _vm.form.fecha_desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha_desde", $$v)
                          },
                          expression: "form.fecha_desde"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.form.id_estado != 2 &&
                  this.form.id_estado != 1 &&
                  this.form.id_estado != 64
                    ? _c(
                        "v-flex",
                        { attrs: { md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.itemsDisponibles,
                              "item-text": "nro_item",
                              "item-value": "nro_item",
                              rules: _vm.$validate(["required"]),
                              required: "",
                              label: "ITEM:",
                              loading: _vm.loading
                            },
                            on: {
                              change: function($event) {
                                return _vm.cargarDatos()
                              }
                            },
                            model: {
                              value: _vm.form.nro_item,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "nro_item", $$v)
                              },
                              expression: "form.nro_item"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.form.id_estado != 1 && this.form.id_estado != 64
                    ? _c(
                        "v-flex",
                        { attrs: { md4: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.unidades,
                              "item-text": "nombre_unidad",
                              "item-value": function(val) {
                                return parseInt(val.id)
                              },
                              label: "Unidad",
                              rules: _vm.$validate(["required"]),
                              required: "",
                              disabled: ""
                            },
                            on: { change: _vm.obtenerOrganigrama },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(data) {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          staticClass: "tree--rounded",
                                          attrs: { left: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c("div", _vm._g({}, on), [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            data.item
                                                              .nombre_unidad
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ])
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("v-treeview", {
                                            staticClass: "white--text pa-1",
                                            attrs: {
                                              open: [1, 2],
                                              items: data.item.organigrama,
                                              "item-key": "id"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "prepend",
                                                  fn: function(ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass:
                                                            "white--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                item.icon
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.tree,
                                              callback: function($$v) {
                                                _vm.tree = $$v
                                              },
                                              expression: "tree"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              405916910
                            ),
                            model: {
                              value: _vm.form.id_unidad,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "id_unidad", $$v)
                              },
                              expression: "form.id_unidad"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  this.form.id_estado != 1 && this.form.id_estado != 64
                    ? _c(
                        "v-flex",
                        { attrs: { md4: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.cargos,
                              "item-text": "cargo",
                              "item-value": function(val) {
                                return parseInt(val.id_cargo)
                              },
                              label: "Cargo",
                              rules: _vm.$validate(["required"]),
                              required: "",
                              disabled: ""
                            },
                            model: {
                              value: _vm.form.id_cargo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "id_cargo", $$v)
                              },
                              expression: "form.id_cargo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.form.id_estado != 2 &&
                  this.form.id_estado != 1 &&
                  this.form.id_estado != 64
                    ? _c(
                        "v-flex",
                        { attrs: { md4: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.puestos,
                              "item-text": "denominacion",
                              "item-value": function(val) {
                                return parseInt(val.id)
                              },
                              label: "Puesto",
                              rules: _vm.$validate(["required"]),
                              disabled: ""
                            },
                            model: {
                              value: _vm.form.id_puesto,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "id_puesto", $$v)
                              },
                              expression: "form.id_puesto"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.form.id_estado != 1 && this.form.id_estado != 64
                    ? _c(
                        "v-flex",
                        { attrs: { md4: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.itemsDisponibles,
                              "item-text": "sueldo",
                              "item-value": function(val) {
                                return val.sueldo
                              },
                              rules: _vm.$validate(["required"]),
                              required: "",
                              disabled: "",
                              label: "Sueldo",
                              loading: _vm.loading
                            },
                            model: {
                              value: _vm.form.sueldo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "sueldo", $$v)
                              },
                              expression: "form.sueldo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("small", { staticClass: "error--text text-required" }, [
            _vm._v("* Los campos son obligatorios")
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              nativeOn: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [
              _c("v-icon", [_vm._v("cancel")]),
              _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + "\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.fecha_futuro,
                  expression: "!fecha_futuro"
                }
              ],
              attrs: {
                color: "primary",
                type: "submit",
                loading: _vm.loading,
                disabled: !_vm.valid
              }
            },
            [
              _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
              _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-418b0c6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418b0c6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/components/CambioItem.vue
// module id = null
// module chunks = 